export default __webpack_public_path__ + "static/media/scoreboard.6dea1c97.svg";